import api from "../../../lib/API";

export const addActivity = async (id, data) => {
  const response = await api.post(`/verve-leads/${id}/activities`, data);
  return response.data || response;
};
